import styled from 'styled-components';

const YadoItemView = styled.a`
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  background-color: var(--gray0);
  border: 1px solid var(--gray600);
  margin-bottom: 16px;
  text-decoration: none;
  &:hover {
    border: 1px solid var(--blue600);
    box-shadow: 0px 4px 10px 0 rgba(53, 118, 172, 0.15);
    text-decoration: none;
  }
`;

export default YadoItemView;
